import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { category, filter, scooter, modal1 } from "../../constant/Index";
import "../../assets/Css/products.css";
import { Link, useNavigate } from "react-router-dom";
import { useAllProductsQuery } from "../../store/services/ProductsServices";
import currency from "currency-formatter";
import { useForm } from "./../../hooks/Form";
import {
	useBrandsQuery,
	useCategoriesQuery,
} from "../../store/services/CategoryService";
import { createApi } from "@reduxjs/toolkit/query/react";
import { useSiteSettingsQuery } from "../../store/services/HomeServices";
import Spinner from "./../../utils/Loader";
import { useSiteSettingUrlQuery } from "../../store/services/SiteSettingServices";
import { useSelector, useDispatch } from "react-redux";
import { useApplyInterestMutation } from "../../store/services/InterestService";
import {
	clearVechicle_ID,
	setVechicle_ID,
} from "../../store/reducers/globalReducers";

const Products = () => {
	const { userToken, user } = useSelector((state) => state.AuthReducer);
	const { data: ImageUrl, isFetching: ImageLoad } = useSiteSettingUrlQuery();
	const [sendVehiclesId, setVechicles] = useState();
	const { state, onChange } = useForm({
		search: "",
		carsCate: "",
		carsBrands: "",
	});
	const [cateId, setCateId] = useState(null);
	const [brandsId, setBrandsId] = useState(null);
	const [keyword, setKey] = useState(null);
	const [checktrue, setCheck] = useState(false);
	const searching = (e) => {
		e.preventDefault();
		if (state.search.replace(/\s/g, "").length <= 0) {
			return setCheck(false);
		}
		setKey(state.search);
		setCheck(true);
	};
	let [limits, setLimit] = useState(3);
	const { data, isLoading } = useAllProductsQuery({
		search: checktrue ? keyword : "",
		cate: cateId ? cateId : "",
		brands: brandsId ? brandsId : "",
	});
	const { data: Brands, isLoading: brandload } = useBrandsQuery();
	const [sendInterest, response] = useApplyInterestMutation();
	const { data: Response, isFetching: load } = useSiteSettingsQuery();
	const dispatch = useDispatch();
	const LoadMore = (e) => {
		e.preventDefault();
		setLimit((preValue) => preValue + 1);
	};
	const { data: CateResponse, isFetching: CatLoad } = useCategoriesQuery();

	const wordKey = () => {
		if (state.search.replace(/\s/g, "").length <= 0) {
			return setCheck(false);
		}
		setKey(state.search);
		setCheck(true);
	};

	const HandleSendCate = () => {
		setCateId(state?.carsCate);
	};
	const HandleSendBrand = () => {
		setBrandsId(state?.carsBrands);
	};

	console.log(state?.carsBrands);

	const setInterestCard = (e, id) => {
		e.preventDefault();
		setVechicles(id);
		const FormDatas = new FormData();
		FormDatas.append("user_id", user?.id);
		FormDatas.append("vehicle_id", id);
		sendInterest(FormDatas);
	};

	useEffect(() => {
		wordKey();
	}, [state.search]);

	useEffect(() => {
		return () => {
			dispatch(clearVechicle_ID());
		};
	}, []);

	let navigate = useNavigate();
	return (
		<>
			{!isLoading ? (
				<>
					<Header />

					{/* Home and product sec  */}
					<section className="home-and-pro-sec">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="home-and-product">
										<p>
											<Link to="/">Home</Link>
											{">"}
											<Link to="/">Products</Link>
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>

					{/* End of Home product sec  */}

					{/* Inner banner heading  */}
					<section className="inner-banner">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="inner-banner-head">
										<div
											dangerouslySetInnerHTML={{
												__html:
													Response?.response?.data[0]
														?.products_heading_and_para,
											}}
										></div>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* End of Inner heading  */}

					{/* Row for seacrh Bar  */}
					<section className="saerch-sec">
						<div className="container">
							<div className="row">
								<div className="col-lg-5 col-md-5 ml-auto pr-5">
									<div className="search-bar  mr-4 mr-lg-5 mr-md-5 mr-sm-5">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="exampleInputEmail1"
												aria-describedby="emailHelp"
												placeholder="Search"
												name="search"
												value={state.search}
												onChange={onChange}
											/>
										</div>
										<div className="search-icon" onClick={searching}>
											<i class="fa fa-search" aria-hidden="true"></i>
										</div>
									</div>
								</div>

								<div className="col-xl-3 col-lg-4 col-md-5">
									<div className="category-pic-text for-flex-right">
										<span
											className="text-spanss d-flex align-items-center gap-2"
											style={{ gap: "7px" }}
										>
											<img className="img-fluid" src={category}></img>
											<span>Category:</span>
										</span>
										<div className="select-category">
											<select
												name="carsCate"
												id="cars"
												onChange={onChange}
												onClick={HandleSendCate}
											>
												<option disabled selected>
													Select Category
												</option>
												{CateResponse?.response?.data?.map((item, index) => {
													return (
														<option value={item?.id} key={index}>
															{item?.name}
														</option>
													);
												})}
											</select>
										</div>
									</div>
								</div>

								<div className="col-md-3 mr-auto">
									<div className="category-pic-text for-flex-center">
										<span className="text-span d-flex align-items-center gap-3" style={{ gap: "7px" }}>
											<img className="img-fluid" src={filter}></img>
											<span> Brands: </span>
										</span>
										<div className="select-category" style={{ paddingLeft: "10px" }}>
											<select
												id="cars"
												name="carsBrands"
												onChange={onChange}
												onClick={HandleSendBrand}
											>
												<option disabled selected>
													Select Brands
												</option>
												{Brands?.response?.data?.map((item, index) => {
													console.log(item);
													return (
														<option value={item?.id} key={index}>
															{item?.name}
														</option>
													);
												})}
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* End Of row Seacrh Bar  */}

					{/* Premiuim Product section  */}
					<section className="product-sec">
						<div className="container">
							<div class="before">
								<figure>
									<img
										src="/static/media/left-before.b936497cd146b61f30b1.png"
										alt=""
										class="img-fluid"
									/>
								</figure>
							</div>
							<div className="row">
								{data?.response?.data?.slice(0, limits).map((item, index) => {
									return (
										<div
											className="col-lg-4 col-md-6"
											style={{ cursor: "pointer" }}
											key={index}
										>
											<div className="product-box">
												<div
													className="product-img"
													onClick={() => navigate(`/productdetail/${item?.id}`)}
												>
													<img
														className="img-fluid"
														src={`${ImageUrl?.uploads}${item?.image}`}
													></img>
												</div>
												<div className="product-price">
													<div className="pro-text">
														<h3>{item?.title}</h3>
													</div>
													<div className="price">
														<p>Starting from</p>
														<h5>
															{item?.price &&
																currency
																	.format(item?.price, { code: "USD" })
																	.split(".")[0]}
														</h5>
													</div>
												</div>
												<div className="pro-para">
													<p className="mt-2">{item?.sub_title}</p>
												</div>

												<div className="btn-color">
													<div className="button-group product-btn">
														{!userToken ? (
															<button
																onClick={() => navigate("/login")}
																className="flit-btn"
															>
																<span className="for-txt">I am Interested</span>
																<span className="for-hover"></span>
															</button>
														) : (
															<button
																className="flit-btn"
																data-toggle="modal"
																data-target="#exampleModalCenter"
																onClick={(e) => setInterestCard(e, item?.id)}
															>
																<span className="for-txt">I am Interested</span>
																<span className="for-hover"></span>
															</button>
														)}
														<span>
															<div className="fo-nam">
																<span>
																	<p>Colors:</p>
																</span>
																{/* <input className="black" type="radio"></input>
												<input className="white" type="radio"></input>
												<input className="red" type="radio"></input>
												<input className="blue" type="radio"></input> */}
																{item?.colors
																	?.slice(0, 4)
																	?.map((col, index) => {
																		return (
																			<>
																				{/* <input
																		className={col?.name.toLowerCase()}
																		type="radio"
																	></input> */}
																				<span
																					className="cirlceStyle"
																					style={{
																						background: `${col?.name.toLowerCase()}`,
																					}}
																				></span>
																			</>
																		);
																	})}
															</div>
														</span>
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</div>
							{data?.response?.data.length <= 0 && (
								<h3 style={{ textAlign: "center", marginTop: "20px" }}>
									Product Not Founds
								</h3>
							)}
							{data?.response?.data.length <= limits ? (
								<></>
							) : (
								<div className="load-more-btn">
									<button onClick={LoadMore}>Load More</button>
								</div>
							)}
							<div class="right-before">
								<figure>
									<img
										src="/static/media/easy-before.e66c4407932666308811.png"
										alt=""
										class="img-fluid"
									/>
								</figure>
							</div>
						</div>
					</section>
					{/* <End of Premium Product section  */}
					<Footer />
					<div
						class="modal applyforloan_page fade"
						id="exampleModalCenter"
						tabindex="-1"
						role="dialog"
						aria-labelledby="exampleModalCenterTitle"
						aria-hidden="true"
					>
						<div class="modal-dialog apply-loan h-100" role="document">
							<div class="modal-content ">
								<div class="modal-body ">
									<div className="apply-loan h-100">
										<div className="row py-5">
											<div className="col-md-5  ">
												<div className="apply-loan-img">
													<img className="img-fluid" src={modal1}></img>
												</div>
											</div>

											<div className="col-md-6">
												<div className="modal-apply-loan-text">
													<h3>Would You Like To</h3>
													<h2>Apply for Loan</h2>
													<p>
														Vitae semper quis lectus nulla at volutpat diam ut.
														Adipiscing elit pellentesque habitant morbi
														tristique.{" "}
													</p>
													<div className="two-btns-apply-loan">
														<button
															className="bg-btn"
															style={{ cursor: "pointer" }}
															onClick={(e) => {
																e.preventDefault();
																dispatch(setVechicle_ID(sendVehiclesId));
																localStorage.setItem(
																	"setVechicle_ID",
																	sendVehiclesId,
																);
																window.location.href = "/applyforloan";
															}}
														>
															Yes
														</button>
														<button data-dismiss="modal">Not Now</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default Products;
